export type SplitAddress = {
    street: string;
    number: string;
};

export function splitAddress(address: string): SplitAddress {
    let match = /^(.+?)\s+(\d.*)$/.exec(address.trim());
    if (!match) {
        return { street: address.trim(), number: '' };
    }
    return { street: match[1], number: match[2] };
}
